import axios, { AxiosResponse } from 'axios';
import { FetchUserLoungesType } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

function shouldRetry(err: any): boolean {
  if (!axios.isAxiosError(err)) return false;
  const status = err.response?.status;
  return status == null || status >= 500 || status === 429;
}

export const getAllUserLoungesApi = async ({
  sortType,
  UserId,
  currentPage,
}: FetchUserLoungesType) => {
  const responseBody = (response: AxiosResponse) => response.data;
  const token = localStorage.getItem('token');
  const apiEndpoint =
    GET_BASE_URL +
    '/api/v1/user/' +
    UserId +
    '/myposts' +
    `?page=${currentPage}`;

  const getRequest = async (url: string) => {
    try {
      return await axios
        .get<Lounge[]>(url, {
          headers: {
            ...(token ? { Authorization: `bearer ${token}` } : {}),
          },
        })
        .then(responseBody);
    } catch (err) {
      if (!shouldRetry(err)) throw err;
      await sleep(650);
      return await axios
        .get<Lounge[]>(url, {
          headers: {
            ...(token ? { Authorization: `bearer ${token}` } : {}),
          },
        })
        .then(responseBody);
    }
  };

  const { data } = await getRequest(`${apiEndpoint}`);

  return data;
};
